// extracted by mini-css-extract-plugin
export default {"title":"AboutModal_title__3rOTF"};